import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

/**
 * Notification Center presentation API client。
 * 僅 unread-count facade；不是 All feed / unified list。
 */
export const notificationCenterApi = {
  getUnreadCount: () => travelClient.get(travelEndpoints.meNotificationCenterUnreadCount),
};
